import { QualificationFilter, SelectType } from "@bonliva-crm/graphql";
import locale from "@bonliva-crm/locale";
import { Tab, Tabs, capitalize } from "@material-ui/core";
import { Color } from "@bonliva-crm/ui";
import { Professions } from "@bonliva-crm/shared";

export type Option = { label: string; value: string; parent?: string };

export type OptionQualification = {
  label: typeof locale.Yes | typeof locale.No | typeof locale.All;
  value: QualificationFilter;
};

export type ProfessionFilterModalInnerProps = {
  value: any;
  onChange: (value: any) => void;
};

export const getProfessionToValue = (profession: string): string => {
  switch (profession) {
    case Professions.SE_ARBETSTERAPEUT:
    case Professions.SE_FYSIOTERAPEUT:
    case Professions.SE_SSK:
    case Professions.DK_SYGEPLEJERSKER:
    case Professions.NO_SYKEPLEIE:
    case Professions.FI_SAIRAANHOITAJA:
      return "sskForm";

    case Professions.SE_LAKARE:
    case Professions.NO_LEGE:
    case Professions.DK_LAEGER:
    case Professions.FI_LAAKARI:
      return "doctor";

    case Professions.SE_LARARE:
      return "teacherForm";

    case Professions.SE_RONTGENSJUKSKOTERSKA:
    case Professions.DK_RADIOGRAFER:
    case Professions.DK_SOCIAL_OG_SUNDHEDSASSISTENT:
      return "radiographer";

    case Professions.SE_SOCIONOM:
      return "socialWorkerForm";

    case Professions.SE_PSYKOLOG:
      return "psykolog";

    case Professions.DK_JORDEMODER:
    case Professions.SE_AUDIONOM:
    case Professions.SE_BARNMORSKA:
    case Professions.SE_BIOMEDICINSK_ANALYTIKER:
    case Professions.SE_DIETIST:
    case Professions.SE_FARMACEUTER:
    case Professions.SE_HALSO_OCH_SJUKVARDKURATOR:
    case Professions.SE_INTERNREKRYTERING:
    case Professions.SE_MEDICINSKA_SEKRETERARE:
    case Professions.SE_PSYKOTERAPEUT:
    case Professions.SE_USK:
    case Professions.DK_PLEJER:
    case Professions.DK_PSYKIATRIMEDARBEJDER:
    case Professions.DK_SOCIALPAEDAGOG:
    case Professions.DK_SOCIAL_OG_SUNDHEDSHJAELPER:
    case Professions.DK_HJAELPEPLEJER:
    case Professions.DK_OMSORGSMEDARBEJDER:
    case Professions.DK_PAEDAGOGMEDHJAELPER:
      return "expOnly";

    default:
      return "";
  }
};

export function encodeValue(aoe: string, spec: string) {
  return `${aoe}|||${spec}`;
}

/**
 * Selected values are stored encoded (`aoe|||spec`, or `aoe|||*` for a whole
 * group). Chips and the filter badge render `label`, so show the readable part.
 */
export function toDecodedLabelValue(values: string[]): Option[] {
  return values.map((value) => {
    const [aoe, spec] = value.split("|||");
    const label = spec === undefined ? value : spec === "*" ? aoe : spec;
    return { label, value };
  });
}

export const renderSelectType = (value: string, onChange: (s: string) => void) => {
  return (
    <Tabs
      value={value}
      style={{
        boxShadow: "none"
      }}
    >
      {[SelectType.ANY, SelectType.AND, SelectType.ONLY].map((tab) => (
        <Tab
          style={{ width: "33.33%", color: Color.Body }}
          // @ts-ignore
          label={locale[`Search${capitalize(tab.toLowerCase())}`]}
          value={tab}
          onClick={() => onChange(tab)}
        />
      ))}
    </Tabs>
  );
};
